/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface IRecoverAccountScope extends ng.IScope {
        vm: RecoverAccount;
        recoverUsername: ng.IFormController;
    }

    interface IRecoverAccount {
        tabs: Array<any>;
        step: number;
        username: string;
        email: string;
        securityQuestion: string;
        securityAnswer: string;
        recoveryOption: number;
        recoverPassword: IRecoverPassword;
        recoverUsername: IRecoverUsername;
        passwordResetAccounts: Array<IPasswordResetAccount>
        errors: Array<string>;
        passwordResetAccountId: string;
    }

    interface IRecoverPassword {
        securityAnswer: string;
        username: string;
        lastName: string;
        newPassword: string;
        confirmPassword: string;
    }
    
    interface IRecoverUsername {
        securityAnswer: string;
        firstName: string;
        lastName: string;
        email: string;
    }

    interface IPasswordResetAccount {
        id: number;
        firstName: string;
        lastName: string;
        salutation: string;
    }
    
    class RecoverAccount implements IRecoverAccount {
        static controllerId: string = "recoverAccount";
        static $inject: Array<string> = ["$scope", "$timeout", "common", "Restangular", "$routeParams", "$location"];
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;
        tabs: Array<any>;
        step: number = 1;
        username: string;
        email: string;
        securityQuestion: string;
        securityAnswer: string;
        recoverPassword: IRecoverPassword;
        recoveryOption: number;
        recoverUsername: IRecoverUsername;
        errors: Array<string> = [];
        passwordResetAccounts: Array<IPasswordResetAccount>;
        passwordResetAccountId: string;
        passwordResetAccount: any;


        constructor(
            private $scope: IRecoverAccountScope,
            private $timeout: ng.ITimeoutService,
            private common: ICommonFactory,
            private Restangular: Restangular.IService,
            private $routeParams,
            private $location: ng.ILocationService) {

            common.authentication.redirectAuthenticated("/");
            this.log = common.logger.getLogFn(RecoverAccount.controllerId);
            this.logError = common.logger.getLogFn(RecoverAccount.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(RecoverAccount.controllerId, "success");

            var option: string = $routeParams["option"];
            if (option) {
                switch (option.toLowerCase()) {
                    case "forgotpassword":
                        this.recoveryOption = 1;
                        break;
                    case "forgotaccountname":
                        this.recoveryOption = 2;
                        break;
                    case "requestpasswordreset":
                        this.recoveryOption = 3;
                        break;
                }
            }

           this.activate();
            
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, RecoverAccount.controllerId)
                .then(() => {
                this.log("Activated RecoverAccount View");
                });
        }

        getSecurityQuestion = () => {
            this.errors = [];
            switch (this.recoveryOption) {
                case 1:
                    this.Restangular.all("Account/GetSecurityQuestion/ForgotPassword").post(this.recoverPassword)
                        .then((result) => {
                        this.securityQuestion = result;
                        this.step = 2;
                        }, (reason) => {
                            if (reason.status == 404) {
                                this.errors = [];
                                this.errors.push("Your account was not found, or the information you entered is inaccurate.");
                                this.logError(this.errors, reason, true);
                            }
                        });
                    break;
                case 2:
                case 3:
                    this.Restangular.all("Account/GetSecurityQuestion/ForgotUsername").post(this.recoverUsername)
                        .then((result) => {
                            this.securityQuestion = result;
                            this.step = 2;
                        }, (reason) => {
                            if (reason.status == 404) {
                                this.errors = [];
                                this.errors.push("Your account was not found, or the information you entered is inaccurate.");
                                this.logError(this.errors, reason, true);
                            }
                        });
                    break;
            }


            
        };

        recoverAccount = () => {
            switch (this.recoveryOption) {
                case 1:
                    this.recoverPassword.securityAnswer = this.securityAnswer;
                    this.Restangular.all("account/ResetPassword").post(this.recoverPassword)
                        .then((result) => {
                            this.step = 3;
                        }, (reason) => {
                            if (reason.status == 400) {
                                this.getErrors(reason.data.modelState);
                                this.logError(this.errors, reason, true);

                            }
                            else {
                                this.logError(reason, reason, true);
                            }
                        });
                    break;

                case 2:
                    this.recoverUsername.securityAnswer = this.securityAnswer;
                    this.Restangular.all("account/RecoverUsername").post(this.recoverUsername)
                        .then((result) => {
                        this.username = result;
                        this.step = 3;

                        }, (reason) => {
                            if (reason.status == 400) {
                                this.getErrors(reason.data.modelState);
                                this.logError(this.errors, reason, true);
                            }
                            else {
                                this.logError(reason, reason, true);
                            }
                            
                        });
                    break;
                default:
                    break;

                       
            }

        };

        selectRecoveryOption = (option: number) => {
            this.recoveryOption = option;
            this.errors = [];
        };

        
        getErrors = (modelState: any) => {
            this.errors = [];
            for (var key in modelState) {
                this.errors.push(modelState[key][0]);
            };
        };

        getPasswordResetAccounts = () => {
            this.Restangular.all("users").one("PasswordResetAccounts", this.username).get()
                .then((result) => {
                this.passwordResetAccounts = result;
                this.step = 2;
                }, (reason) => {
                    if (reason.status == 400) {
                        this.getErrors(reason.data.modelState);
                        this.logError(this.errors, reason, true);
                    }
                    else if (reason.status == 404) {
                        this.logError("Your account was not found, or the information you entered is inaccurate.", reason, true);
                    }
                    else {
                        this.logError(reason, reason, true);
                    }
                    
                });
                

        };
        
        sendResetRequest = () => {
            var model = {
                accountId: parseInt(this.passwordResetAccountId),
                username: this.username
            };

            this.Restangular.all("users/sendPasswordResetRequest").post(model)
                .then((result) => {
                this.step = 3;
                this.passwordResetAccount = _.find(this.passwordResetAccounts, (p) => {
                    return p.id == parseInt(this.passwordResetAccountId);
                });
                }, (reason) => {
                    this.logError(reason, reason, true);
                });

        };


        
    }

    angular.module("app").controller(RecoverAccount.controllerId, RecoverAccount);
}